import { combineReducers } from "redux";
import scheduleReducer from "./schedule/scheduleReducer";
import standingsReducer from "./standings/standingsReducer";
import uiReducer from "./ui/uiReducer";

export default combineReducers({
  scheduleReducer,
  standingsReducer,
  uiReducer
});



// WEBPACK FOOTER //
// ./src/store/reducers.js